import React, { useEffect, useState } from 'react';
import '../mail/SendMailScreen.css';
import '../mail/SentMailList.css';
import '../styles/MainContainer.css';
import SendMailScreen from '../mail/SendMailScreen';
import SentMailList from '../mail/SentMailList';
import { useParams } from 'react-router-dom';
import api from '../wrapper/API';
import OfflineBanner from '../shell/OfflineBanner';

function Mail() {
  const { eventId } = useParams();
  const { playerId } = useParams();

  const [postEvent, setPostEvent] = useState({});
  const [postPlayer, setPostPlayer] = useState({});
  const [mailRefresh, setMailRefresh] = useState(0);

  useEffect(() => {
    api.get(`/Event/GetById?eventId=${eventId}`)
      .then(response => {
        setPostEvent(response.data);
      })
      .catch(() => {

      });

    api.get(`/Player/GetPlayerById?playerId=${playerId}`)
      .then(response => {
        setPostPlayer(response.data);
      })
      .catch(() => {

      });
  }, [eventId, playerId]);

  return (
    <React.Fragment>
      <main className={'wideMain'}>
        <OfflineBanner />
        <SendMailScreen
          postEvent={postEvent}
          setPostEvent={setPostEvent}
          postPlayer={postPlayer}
          setPostPlayer={setPostPlayer}
          onMailSent={() => setMailRefresh(r => r + 1)}
        />
        <SentMailList
          eventId={postEvent?.id}
          playerId={postPlayer?.id}
          refreshTrigger={mailRefresh}
        />
      </main>
    </React.Fragment>
  );
}

export default Mail;